export default "__VITE_ASSET__DW0U4Vnd__"